import { eventEmitter, persist } from './utils';
import { fromLonLat } from 'ol/proj';
import { setupUI } from './ui';

export const state = eventEmitter({});

setupUI(state);

export function load() {
    let loadState = localStorage.getItem('state')
    if (loadState) {
        Object.assign(state, JSON.parse(loadState));
    } else {
        Object.assign(state, {
            epsg: 'EPSG:4326',
            track: true,
            fix: false,
            gps: fromLonLat([21.62730157317441, 47.504920400338]),
            fixOffset: [0, 0],
            tiltOffset: [0, 0]
        });
    }

    persist(state)
}
